import _ from 'lodash'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

const mapScheduleTypeFilter = (item) => {
  return {
    label: item?.value_list_name,
    value: item?.value_list_id,
  }
}

export const getActionTypeApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/action_type',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapScheduleTypeFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
